<!--
  role2/role3/role5 我的页红包图片弹窗
  - 5 分钟倒计时（限时：时分秒）
  - 5 秒无点击自动关闭（不展示浮窗）；遮罩不可关，仅关闭按钮可手动关闭
  - 点击调起支付；支付成功后展示欢乐歌房引导弹窗
-->

<template>
  <div
    v-show="value"
    class="mine-redbag-wrapper"
    :class="{ 'mine-redbag-wrapper--guide': mode === 'guide' }"
    @click.self="mode === 'guide' ? handleMaskClick : undefined"
  >
    <div
      v-if="showClose && value && mode === 'redbag'"
      class="mine-redbag-close"
      @click.stop="handleRedbagClose"
    >
      <img
        src="https://qncweb.ktvsky.com/20250422/vadd/25adc9123e22d052f2c15bbfe0460227.png"
        alt="关闭"
        draggable="false"
      >
    </div>
    <transition name="fade">
      <div v-if="value" class="mine-redbag-panel" :class="`mine-redbag-panel--${mode}`">
        <!-- 红包主弹窗 -->
        <template v-if="mode === 'redbag'">
          <div v-if="countdownEndAt" class="mine-redbag-countdown">
            <span class="mine-redbag-countdown__label">限时：</span>
            <div class="mine-redbag-countdown__blocks">
              <span class="mine-redbag-countdown__block">{{ countdownParts.h }}</span>
              <span class="mine-redbag-countdown__sep">:</span>
              <span class="mine-redbag-countdown__block">{{ countdownParts.m }}</span>
              <span class="mine-redbag-countdown__sep">:</span>
              <span class="mine-redbag-countdown__block">{{ countdownParts.s }}</span>
            </div>
          </div>
          <div
            ref="redbagImg"
            class="mine-redbag-img-wrap"
            @click.stop="handleRedbagClick"
          >
            <img
              class="mine-redbag-img"
              :src="redbagImg"
              alt="红包弹窗"
              @load="onImgLoad"
            >
          </div>
        </template>

        <!-- 支付成功后欢乐歌房引导弹窗 -->
        <template v-else>
          <div
            ref="guideImg"
            class="mine-redbag-guide-wrap"
          >
            <button
              type="button"
              class="mine-redbag-guide-close"
              aria-label="关闭"
              @click.stop="handleGuideClose"
            >
            </button>
            <img
              class="mine-redbag-guide-img"
              :src="guideImg"
              alt="欢乐歌房"
              @click.stop="handleGuideClick"
              @load="onImgLoad"
            >
          </div>
        </template>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  MINE_HAPPY_ROOM_GUIDE_IMG,
  CLOSE_IMG,
} from './happyRoom'

const FIVE_MIN_MS = 5 * 60 * 1000
const AUTO_SHRINK_MS = 5000

function pad2(n) {
  return String(n).padStart(2, '0')
}

function formatHMS(ms) {
  const totalSec = Math.max(0, Math.floor(ms / 1000))
  const h = Math.floor(totalSec / 3600)
  const m = Math.floor((totalSec % 3600) / 60)
  const s = totalSec % 60
  return `${pad2(h)}:${pad2(m)}:${pad2(s)}`
}

export default {
  name: 'RaiseBoxMineRedbag',

  props: {
    modal: {
      default: false,
    },
  },

  data() {
    return {
      value: false,
      mode: 'redbag',
      redbagImg: '',
      guideImg: MINE_HAPPY_ROOM_GUIDE_IMG,
      closeImg: CLOSE_IMG,
      countdownText: '05:00:00',
      countdownEndAt: 0,
      countdownTimer: null,
      autoShrinkTimer: null,
      userInteracted: false,
      onRedbagClick: null,
      onGuideDownload: null,
      onGuideClose: null,
      imgLoaded: false,
      showClose: true,
      closeCallback: null,
    }
  },

  computed: {
    countdownParts() {
      const [h = '00', m = '00', s = '00'] = (this.countdownText || '').split(':')
      return { h, m, s }
    },
  },

  methods: {
    show(options = {}) {
      this.mode = 'redbag'
      this.redbagImg = options.redbagImg || ''
      this.onRedbagClick = options.onRedbagClick || null
      this.closeCallback = options.closeCallback || null
      this.showClose = options.showClose !== false
      this.userInteracted = false
      this.imgLoaded = false
      this.value = true
      this.startFiveMinCountdown()
      this.startAutoShrinkTimer()

      this.$sendLog({
        event_type: 'show',
        event_name: '我的页红包弹窗展示',
        event_data: {
          role: this.$store?.state?.role,
        },
      })
    },

    showGuide({ onDownload, onClose } = {}) {
      this.clearTimers()
      this.mode = 'guide'
      this.onGuideDownload = onDownload || null
      this.onGuideClose = onClose || null
      this.userInteracted = true
      this.imgLoaded = false
      this.value = true

      this.$sendLog({
        event_type: 'show',
        event_name: '我的页欢乐歌房引导弹窗展示',
      })
    },

    close() {
      this.value = false
      this.clearTimers()
    },

    doClose() {
      this.close()
    },

    onImgLoad() {
      this.imgLoaded = true
    },

    startFiveMinCountdown() {
      this.countdownEndAt = Date.now() + FIVE_MIN_MS
      this.updateCountdownText()
      this.clearCountdownTimer()
      this.countdownTimer = setInterval(() => {
        this.updateCountdownText()
        if (Date.now() >= this.countdownEndAt) {
          this.clearCountdownTimer()
        }
      }, 1000)
    },

    updateCountdownText() {
      const remain = this.countdownEndAt - Date.now()
      this.countdownText = formatHMS(remain)
    },

    startAutoShrinkTimer() {
      this.clearAutoShrinkTimer()
      this.autoShrinkTimer = setTimeout(() => {
        if (!this.userInteracted && this.value && this.mode === 'redbag') {
          this.autoCloseRedbag()
        }
      }, AUTO_SHRINK_MS)
    },

    autoCloseRedbag() {
      if (!this.value || this.mode !== 'redbag') return
      this.userInteracted = true
      this.close()
    },

    getGuideImgRect() {
      try {
        const el = this.$refs.guideImg
        if (!el || typeof el.getBoundingClientRect !== 'function') return null
        return el.getBoundingClientRect()
      } catch (e) {
        return null
      }
    },

    handleRedbagClick() {
      this.userInteracted = true
      this.clearAutoShrinkTimer()
      if (typeof this.onRedbagClick === 'function') {
        this.onRedbagClick()
      }
    },

    handleRedbagClose() {
      this.userInteracted = true
      this.clearAutoShrinkTimer()
      if (typeof this.closeCallback === 'function') {
        this.closeCallback()
      }
      this.close()
    },

    handleGuideClick() {
      this.$sendLog({
        event_type: 'click',
        event_name: '我的页欢乐歌房引导弹窗点击',
      })
      if (typeof this.onGuideDownload === 'function') {
        this.onGuideDownload()
      }
    },

    handleGuideClose() {
      this.$sendLog({
        event_type: 'click',
        event_name: '我的页欢乐歌房引导弹窗关闭',
      })
      const rect = this.getGuideImgRect()
      // 先交给收起动画接管，动画就绪后再关闭弹窗，避免闪一下
      if (typeof this.onGuideClose === 'function') {
        this.onGuideClose(rect)
      } else {
        this.close()
      }
    },

    handleMaskClick() {
      if (!this.modal || this.mode !== 'guide') return
      this.handleGuideClose()
    },

    clearCountdownTimer() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer)
        this.countdownTimer = null
      }
    },

    clearAutoShrinkTimer() {
      if (this.autoShrinkTimer) {
        clearTimeout(this.autoShrinkTimer)
        this.autoShrinkTimer = null
      }
    },

    clearTimers() {
      this.clearCountdownTimer()
      this.clearAutoShrinkTimer()
    },
  },

  beforeDestroy() {
    this.clearTimers()
  },
}
</script>

<style lang="scss" scoped>
.mine-redbag-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.mine-redbag-close {
  position: fixed;
  top: 20px;
  right: 30px;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1002;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.mine-redbag-wrapper--guide {
  align-items: flex-end;
  padding-bottom: 0;
}

.mine-redbag-panel {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.mine-redbag-panel--redbag {
  width: 100%;
}

.mine-redbag-countdown {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
  gap: 12px;
}

.mine-redbag-countdown__label {
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  line-height: 70px;
}

.mine-redbag-countdown__blocks {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mine-redbag-countdown__block {
  width: 60px;
  height: 70px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  line-height: 1;
}

.mine-redbag-countdown__sep {
  font-size: 32px;
  font-weight: 600;
  color: #fff;
  line-height: 70px;
}

.mine-redbag-img-wrap {
  width: 600px;
  cursor: pointer;
}

.mine-redbag-img {
  display: block;
  width: 100%;
  height: auto;
}

.mine-redbag-panel--guide {
  width: 100%;
  padding-bottom: 40px;
}

.mine-redbag-guide-wrap {
  position: relative;
  width: 600px;
  margin: 0 auto;
  border-radius: 20px;
  overflow: hidden;
}

.mine-redbag-guide-close {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 54px;
  height: 54px;
  padding: 0;
  border: none;
  background: transparent;
  z-index: 2;
  cursor: pointer;

  img {
    width: 100%;
    height: 100%;
    display: block;
  }
}

.mine-redbag-guide-img {
  display: block;
  width: 100%;
  height: auto;
  border-radius: 20px;
  cursor: pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
